import script from "./ChatMessageComp.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatMessageComp.vue?vue&type=script&setup=true&lang=js"

import "./ChatMessageComp.vue?vue&type=style&index=0&id=61eed435&scopd=true&lang=css"

const __exports__ = script;

export default __exports__